<template>
    <section class="call-to-action featured featured-primary" id="offer">
        <div class="col">
            <div class="call-to-action-content" style="text-align: left; width: 100%">
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <div class="col-md-9 col-12">
                                <h4>{{ $t('components.prices.static.details') }}</h4>
                                <p>
                                    {{ $t('components.prices.static.periodOfTravel') }}: {{ result.startDate | dateFormat }} - {{ result.endDate | dateFormat }}<br>
                                    {{ $t('components.prices.static.occupants') }}: {{ computeStepTwoTitle }}
                                </p>
                            </div>
                            <div class="col-md-3 col-12" style="text-align: right">
                                <h4>{{ $t('components.prices.common.price') }}</h4>
                                <h2 style="margin-bottom: 0"><span style="font-size: 18px">{{ $t('common.generic.from') }} CHF</span><span style="margin-left: 5px; font-size: 48px">{{result.totalPrice}}</span></h2>
                                <p style="color: grey; font-size: 14px">{{ result.pricePerNight }}.- / {{ $t('components.prices.common.night') }}</p>
                            </div>
                        </div>
                    </div>

                    <slot></slot>
                </div>

                 
                <template v-if="listing"> 
                    <hr class="solid">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <div class="col-12">
                                    <h4>{{ $t('common.keywords.listing') }}</h4>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-3">
                                    <img width="100%" src="http://localhost:8090/images/default/download/full">
                                </div>
                                <div class="col-12 col-md-9">
                                    <h5 class="card-title">{{ listing.localizedName | localized}}</h5>
                                    <p class="locationParagraph"><i class="fas fa-map-marker-alt location"></i>  {{ computeLocation }}</p>
                                    <p class="card-text">{{ listing.localizedDescription | localized}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>


<script>
export default {
    name: 'PriceResult',
    props: {
        result: {
            type: Object,
            required: true,
            default: () => {}
        },
        listing: {
            type: Object,
            required: false
        }
    },
    methods: {
        computeText: function(value, singularStr, pluralStr) {
            if (value == 0) {
                return "";
            }

            return value + " " + (value > 1 ? pluralStr : singularStr);
        },
        
    },
    computed: {
        computeStepTwoTitle: function() {
            return [
                this.computeText(this.result.numberOfAdults, "Adult", "Adults"),
                this.computeText(this.result.numberOfKids, "Kid", "Kids")
            ].filter(val => val !== "").join(", ");
        },
        computeLocation: function() {
            if (this.isUndefined(this.listing) || this.isUndefined(this.listing.address)) {
                return "UNKNOWN";
            }

            return this.listing.address.city;
            // return this.listing.address.street + ", " + this.listing.address.number + " - " + this.listing.address.cap + " " + this.listing.address.city
        },
    }
}
</script>

<style lang="scss" scoped>    
    .call-to-action {
        border-top-color: $primary-color !important;
    }

    #offer {
        padding-left: 20px;
        padding-right: 20px;
    }
</style>